import qs from 'qs';
import type {
    CartRequest,
    CartSummaryApiResponse
} from 'tradera/state/services/types/webapi-shopping-generated';
import { isomorphicWebApiBaseQuery } from './utils/webapi-base-query';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isServer } from 'tradera/utils/nextjs';

export const tagTypes = { CartSummary: 'CartSummary' } as const;

/**
 * Creates a query params object for RTK Query.
 * The query parameters for RTK Query is used as key for caching hence
 * must always be the same for the same query on server and client.
 */
export const getCartSummaryParams = (cartId: string): CartRequest => {
    return { cartId };
};

export const cartApi = createApi({
    reducerPath: 'cartApi',
    baseQuery: isomorphicWebApiBaseQuery,
    tagTypes: Object.values(tagTypes),
    endpoints: (builder) => ({
        getCartSummary: builder.query<CartSummaryApiResponse, CartRequest>({
            providesTags: [tagTypes.CartSummary],
            query: ({ cartId }) => {
                const baseUrl = isServer ? '' : '/api/webapi';
                return `${baseUrl}/shopping/cart?${qs.stringify({ cartId })}`;
            }
        })
    })
});

export const { useGetCartSummaryQuery, endpoints, util } = cartApi;
